"use client";

import { useState } from "react";
import { LayoutList, CalendarDays } from "lucide-react";
import AgendaCalendar from "./agenda-calendar";

type CalEvent = {
  id: string;
  slug: string;
  title: string;
  startDate: string;
  endDate: string | null;
  location: string | null;
  coverImageUrl: string | null;
  category: { name: string } | null;
};

export default function AgendaViewToggle({
  events,
  children,
}: {
  events: CalEvent[];
  children: React.ReactNode;
}) {
  const [view, setView] = useState<"list" | "calendar">("list");

  return (
    <div>
      {/* Toggle buttons */}
      <div className="mb-6 flex items-center gap-2">
        <button
          onClick={() => setView("list")}
          className={[
            "flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium transition",
            view === "list"
              ? "bg-[#1a2744] text-white shadow-sm"
              : "border border-slate-200 bg-white text-slate-600 hover:bg-slate-50",
          ].join(" ")}
        >
          <LayoutList size={15} />
          Liste
        </button>
        <button
          onClick={() => setView("calendar")}
          className={[
            "flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium transition",
            view === "calendar"
              ? "bg-[#1a2744] text-white shadow-sm"
              : "border border-slate-200 bg-white text-slate-600 hover:bg-slate-50",
          ].join(" ")}
        >
          <CalendarDays size={15} />
          Calendrier
        </button>
      </div>

      {view === "list" ? children : <AgendaCalendar events={events} />}
    </div>
  );
}
